import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  list: [],
  single: null,
  loading: false,
  error: null
};

export const storySlice = createSlice({
  name: 'story',
  initialState,
  reducers: {
    addStory: () => {},
    getStory: () => {},
    getOneStory: () => {},
    removeStory: () => {},
    updateStory: () => {},

    successStoryList: (state, action) => {
      state.list = action.payload;
    },

    successSingleStory: (state, action) => {
      state.single = action.payload;
    }
  }
});

export const { addStory, removeStory, updateStory, getStory, getOneStory, successStoryList, successSingleStory } = storySlice.actions;

export default storySlice.reducer;
